module.exports = __webpack_public_path__ + "static/forecast/weather/dayrainshowers-e40bfec10497f17c686873f256f0c9a9.svg";